/**
 * Represents sorting expressions.
 */
export enum SortingDirection {
    None = 0,
    Asc = 1,
    Desc = 2
}

export interface ISortingExpression {
   fieldName: string;
   dir: SortingDirection;
   ignoreCase?: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/data-operations/sorting-expression.interface.ts